export function formatDate(date) {
    let d = new Date(date);
    let formattedDate = d.getFullYear() + '-' + ('0' + (d.getMonth()+1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    return formattedDate;
}